
import { MapColours } from './map-colours';

export class DynamicMapTheme {
	/*
	 * Init the handler
	 *
	 */
	constructor(theme) {
        const mapColours = new MapColours(),
        colours = mapColours[theme];
        
        let styles = [
            {
                "featureType": "all",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": colours.primary
                    },
                    {
                        "weight": "1.02"
                    },
                    {
                        "lightness": "-67"
                    },
                    {
                        "saturation": "0"
                    },
                    {
                        "gamma": "0.50"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": colours.secondary
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "lightness": "-77"
                    },
                    {
                        "saturation": "-5"
                    },
                    {
                        "visibility": "off"
                    },
                    {
                        "color": colours.tertiary
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "gamma": 0.01
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": colours.text
                    }
                ]
            },
            {
                "featureType": "administrative.province",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "administrative.locality",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "color": colours.text
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "lightness": 30
                    },
                    {
                        "saturation": 30
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": colours.tertiary
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "saturation": 20
                    }
                ]
            },
            // {
            //     "featureType": "road",
            //     "elementType": "geometry",
            //     "stylers": [
            //         {
            //             "lightness": 10
            //         },
            //         {
            //             "saturation": -30
            //         }
            //     ]
            // },
            // {
            //     "featureType": "road",
            //     "elementType": "geometry.stroke",
            //     "stylers": [
            //         {
            //             "saturation": 25
            //         },
            //         {
            //             "lightness": 25
            //         }
            //     ]
            // },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "lightness": -20
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "gamma": 8
                    }
                ]
            }
        ];
        return styles;
    }
}
